import { Directive, HostListener, OnInit, ElementRef, Input } from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

@Directive({ selector: '[formatoMoneda]' })
export class FormatoNumeroMonedaCoplementoWebDirective implements OnInit {
	@Input() tipoFormato: 'numero' | 'moneda';
	regexStr = /^[0-9.]*$/;
	actualizarEventoAngular: boolean = true

	constructor(
		private el: ElementRef,
		private currencyPipe: CurrencyPipe,
		private decimalPipe: DecimalPipe
	) {

	}

	ngOnInit() {
		if (!this.el.nativeElement.value) return;
		this.el.nativeElement.value = this.transformar(this.el.nativeElement.value);
	}

	transformar(valor) {
		if (valor == 'undefined') return null;
		const numero = typeof valor === 'string' ? Number(valor.replace(/[^0-9.-]+/g, '')) : valor;

		if (isNaN(numero) || typeof valor == 'undefined') return null;

		return this.tipoFormato === 'numero'
			? this.decimalPipe.transform(numero)
			: this.currencyPipe.transform(numero, 'MXN', 'symbol-narrow');
	}

	@HostListener('keydown', ['$event']) onKeyPress(event) {
		const teclasEsp = ['Backspace', 'Delete', 'Tab', 'Home', 'End'];
		this.actualizarEventoAngular = false
		if (teclasEsp.includes(event.key) || event.key.includes('Arrow')) return;
		return new RegExp(this.regexStr).test(event.key);
	}

	@HostListener("focus", ["$event.target.value"])
	onFocus(value) {
		this.el.nativeElement.value = this.transformar(this.parse(value));
	}

	@HostListener("blur", ["$event.target.value"])
	onBlur(value) {
		this.el.nativeElement.value = this.transformar(this.parse(value));
	}

	@HostListener('click', ["$event.target.value"])
	onClick(value) {
		this.actualizarEventoAngular = false
		this.el.nativeElement.value = this.parse(value); // opossite of transform
	}

	@HostListener('document:click')
	clickOutside(value) {
		this.actualizarEventoAngular = true
	}

	@HostListener('change', ["$event.target.value"])
	ngOnChanges(value) {
		if (typeof value === 'object') return;

		if (value != '')
			this.el.nativeElement.value = this.transformar(this.parse(value));
	}

	@HostListener("ngModelChange", ["$event"]) onNgModelChange(value) {
		if (this.actualizarEventoAngular) {
			this.el.nativeElement.value = this.transformar(this.el.nativeElement.value)
		}
	}

	parse(value: string): number {
		let numberWithoutFormat = null;
		if (value != null && typeof value !== 'undefined' && value != '') {
			let val = value;
			while (val.includes(',')) {
				val = val.replace(',', '');
			}
			val = val.replace('$', '')
			numberWithoutFormat = Number(val);
		}
		return numberWithoutFormat;
	}

}